import { Trans } from "@lingui/react/macro"
import { IconMoodSmile } from "@tabler/icons-react"
import { EditableAnalysisField } from "../../../EditableAnalysisField"
import { SentimentLabel } from "../../parts/SentimentLabel"
import classes from "../../styles.module.css"
import type { IProps } from "./interfaces"

/**
 * SentimentCard renders the analyser's overall sentiment classification with
 * a localised label badge and the descriptive paragraph beneath. Lives in
 * the right-hand insights rail; uses the default brand-tinted side rail.
 */
export function SentimentCard({ sentiment, editContext }: IProps): React.JSX.Element | null {
  if (!sentiment) return null
  return (
    <section className={classes.insight}>
      <div className={classes.insightHead}>
        <IconMoodSmile size={16} color="var(--mantine-color-brand-5)" />
        <h3>
          <Trans>Sentiment</Trans>
        </h3>
        {sentiment.overall && (
          <span className={classes.insightTag}>
            <SentimentLabel overall={sentiment.overall} />
          </span>
        )}
      </div>
      <p className={classes.insightBody}>
        {editContext ? (
          <EditableAnalysisField
            meetingId={editContext.meetingId}
            fieldPath="sentiment.description"
            value={sentiment.description || ""}
            canEdit={editContext.canEdit}
            isEdited={!!editContext.fieldEdits["sentiment.description"]}
            onSaved={editContext.onEdited}
          />
        ) : (
          sentiment.description
        )}
      </p>
    </section>
  )
}
